import PropTypes from 'prop-types'
import enhancer from './enhancer'
import LocaleProvider from './LocaleProvider'

const EnhancedLocaleProvider = enhancer(LocaleProvider)

EnhancedLocaleProvider.propTypes = {
  defaultLocale: PropTypes.string.isRequired
}

export default EnhancedLocaleProvider
